<template>
    <div class="chapter_list" v-show="groupList.data.length">
        <el-table :data="groupList.data" border :header-cell-style="{'padding': 0}" :cell-style="{'padding': '6px 0'}" row-key="id">
            <div slot="empty">
                <img :src="require(`@/assets/image/${noDataName}.png`)" style="width: 100%;padding: 115px 0;"/>
            </div>
            <el-table-column label="排序" prop="sort" width="80">
            </el-table-column>
            <el-table-column label="名称" prop="name" width="320">
            </el-table-column>
            <el-table-column label="操作" align="center" >
                <template slot-scope="scope">
                    <el-row :gutter="20" style="color: #1989FA;font-size: 14px;cursor: pointer;">
                        <el-col :span="6"><span @[typeClick(scope.$index,1)]="editSort('up', scope.$index)" :style="{'cursor': !typeClick(scope.$index,1) ? 'not-allowed': '', 'color': !typeClick(scope.$index,1)? '#ccc': ''}">上移</span></el-col>
                        <el-col :span="6"><span @[typeClick(scope.$index,2)]="editSort('down', scope.$index)" :style="{'cursor': !typeClick(scope.$index,2) ? 'not-allowed': '', 'color': !typeClick(scope.$index,2)? '#ccc': ''}">下移</span></el-col>
                        <el-col :span="6"><span @click="editGroup(scope.row, scope.$index)">编辑</span></el-col>
                        <el-col :span="6"><sapn @click="removeGroup(scope.row, scope.$index)">删除</sapn></el-col>
                    </el-row>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog :title="groupForm.id ? '编辑分组' : '添加分组'"
                   :visible.sync="groupFormVisible" :append-to-body="true" width="20%" @submit.native.prevent @close="handleClose">
                <el-input v-model="groupForm.group_name" autosize autocomplete="off"></el-input>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelGroup" size="medium">取 消</el-button>
                <el-button type="primary" size="medium" @click="submit" :disabled="!groupForm.group_name">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { common } from '@/pages/dy/mixin/common.js'
export default {
    name: 'ChapterGroup',
    mixins: [common],
    props: ['productId'],
    data() {
        return {
            searchObj: {
                is_all: 1,
            },
            noDataName: 'empty',
            groupFormVisible: false,
            currentEditIndex: '',
            groupForm: {
                group_name: '',
            },
            rules: {
                group_name: [
                    {
                        required: true,
                        message: "分组名称不能为空",
                        trigger: "blur",
                    },
                ],
            },
            groupList: {
                data: [],
                total: 0
            },
            groupData: {}
        }
    },
    computed: {
        // ...mapState('chapter',[ 'groupData']),
        ...mapState(['breadCrumbList']),
        typeClick() {
            return (index, type) => {
                if(type == 1) {
                    return index  == 0  ? '': 'click'
                } else {
                    return index == this.groupList.data.length - 1 ? '': 'click'
                }
               
            }
        }
    },
    created() {
        this.getGroupLists()
    },
    methods: {
        ...mapActions('group', ['getGroupList', 'addgroupFun', 'groupsort', 'groupRemove']),
        async getGroupLists() {
            this.searchObj.product_id = this.productId;
            let res = await this.getGroupList(this.searchObj)
            this.groupList = res
        },
        handleClose() {
            this.currentEditIndex = ''
            this.cancelGroup()
        },
        addGroup() {
            this.groupFormVisible = true;
        },
        editGroup(row, index) {
            this.currentEditIndex = index;
            console.log(index, 789909798798789)

            this.groupForm.id = row.id;
            this.groupForm.group_name = row.name;
            this.groupFormVisible = true;
        },
        async removeGroup(row, index) {
            this.$confirm('确定要删除吗？', '信息', {
					distinguishCancelAndClose: false,
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					customClass: this.classNames + '_common_dialog',
					center: true
				})
				.then(async() => {
                    let that = this;
                    await this.groupRemove({
                        id: row.id,
                        product_id: this.productId
                    });
                    this.$message({
                        type: 'success',
                        message: '删除成功',
                        duration: 3000
                    })
                    this.groupList.data.splice(index, 1);
                    this.groupList.data.forEach(function(item, i) {
                        if (item.sort > row.sort) {
                            item.sort -= 1;
                            that.groupList.data[i] = item;
                        }
                    })
				})
        },
        cancelGroup() {
            //清空表单信息
            this.groupForm.id = '';
            this.groupForm.group_name = '';
            //关闭弹窗
            this.groupFormVisible = false;
        },
        async submit() {
             try {
                this.groupForm.product_id = this.productId;
                let res = await this.addgroupFun(this.groupForm);
                this.groupData = res
                let currentIndex = this.currentEditIndex;
                if (currentIndex !== '') {
                    //修改 //将当前行修改掉
                    let editRow = this.groupList.data[currentIndex];
                    editRow.name = this.groupForm.group_name;
                    this.$set(this.groupList.data, currentIndex, editRow);
                    this.currentEditIndex = '';
                } else {
                    //新增 //在列表尾部追加
                    let currentTotal = this.groupList.total;
                    this.groupList.total = currentTotal + 1;
                    this.$set(this.groupList.data, currentTotal, this.groupData);
                    // this.groupList.data = currentData.concat(this.groupData);
                }

                //清空表单信息
                this.groupForm.id = '';
                this.groupForm.group_name = '';
                //关闭弹窗
                this.groupFormVisible = false;
            } catch (error) {
                console.log('error')
            }
        },
        async editSort(action, index) {
            let data = this.groupList.data;
            let current = data[index];
            let currentId = current.id;

            let targetIndex = action === 'up' ? (index - 1) : (index + 1);
            let targetData = data[targetIndex];

            if (targetData === undefined) {
                return '';
            }

            await this.groupsort({
                id: currentId,
                action: action,
                product_id: this.productId
            });
            let currentSort = current.sort;
            current.sort = targetData.sort;
            targetData.sort = currentSort;
            this.groupList.data[index] = targetData;
            this.groupList.data[targetIndex] = current;
        },
    }
}
</script>
<style lang="less" scoped>
    .chapter_list {
        padding-top: 12px;
        .chapter_pag {
            padding: 6px 0;
            line-height: normal;
        }
    }
</style>